import {AfterViewInit, Component, ElementRef, OnInit, ViewChild, ViewEncapsulation} from '@angular/core';
import {Router} from '@angular/router';
import SewingPatternInterface from '../../../models/sewing-pattern.interface';
import {Storage} from '@ionic/storage';
import {ConfiguratorService} from '../../../services/configurator/configurator.service';
import {NavController, ToastController} from '@ionic/angular';
import {PatternTransformService} from '../../../services/pattern/pattern-transform.service';
import {PatternShareService} from "../../../services/pattern/pattern-share.service";
import SewingPatternProject from "../../../models/sewing-pattern-project.model";
import {SafeUrl} from "@angular/platform-browser";

@Component({
    selector: 'app-save-configuration-page',
    templateUrl: './save-configuration-page.component.html',
    styleUrls: ['./save-configuration-page.component.css'],
})
export class SaveConfigurationPageComponent implements OnInit, AfterViewInit {
    @ViewChild('container') container: ElementRef<HTMLElement>;

    private isSaving = false;

    public sewingPattern: SewingPatternInterface;
    public projectName = '';
    public sewingPatternSVG = '';

    public sewingPatternProject: SewingPatternProject;
    public url: SafeUrl;

    public initialized = false;

    constructor(private storage: Storage,
                private configuratorService: ConfiguratorService,
                private shareService: PatternShareService,
                private patternTransformService: PatternTransformService,
                private toastController: ToastController,
                private navController: NavController,
                private router: Router) {
    }

    ngAfterViewInit(): void {
        setTimeout(() => {
            this.initialized = true;

            requestAnimationFrame(() => {
                const $input = this.container.nativeElement.querySelector('input');
                $input.focus();
            });
        }, 300);
    }

    async ngOnInit() {
        this.sewingPatternProject = this.patternTransformService.temporaryPatternProject;
        this.sewingPattern = this.sewingPatternProject.sewingPattern;

        if (!this.patternTransformService.currentPatternIsTemporary) {
            this.projectName = this.patternTransformService.currentPatternProject.name;
        }
    }

    async saveProject() {
        if (this.isSaving) {
            return;
        }

        this.isSaving = true;

        if (this.patternTransformService.currentPatternIsTemporary) {
            const project = await this.configuratorService.savePersonalSewingPattern(
                this.projectName,
                this.sewingPatternProject.sewingPattern,
                await this.patternTransformService.generateFinalSewingPatternSVG(this.sewingPatternProject.sewingPattern, true, `${Date.now()}`)
            );
            await this.configuratorService.saveAsPng(project);
        } else {
            const project = this.patternTransformService.currentPatternProject;
            project.name = this.projectName;
            project.sewingPattern = this.patternTransformService.temporaryPatternProject.sewingPattern;

            await this.configuratorService.updateSewingPatternProject(project);
            await this.configuratorService.saveAsPng(project);
        }

        this.isSaving = false;

        this.router.navigate(['/profile'], {
            replaceUrl: true
        });
    }

    get backTo() {
        if (!this.patternTransformService.currentPatternIsTemporary) {
            return `/configuration/edit/${this.patternTransformService.currentPatternProject.id}`;
        } else {
            return `/configurator/${this.patternTransformService.temporaryPatternProject.sewingPattern.id}`;
        }
    }

    get title() {
        if (this.sewingPattern) {
            return this.sewingPattern.name;
        }

        if (this.projectName) {
            return this.projectName;
        }

        return 'Speichern';
    }
}
